// import categories from "../../data/categories";

// const CategorySidebar = ({ category, setCategory }) => {
//   const sidebarCategories = [
//     {
//       id: "all",
//       title: "All Products",
//     },
//     ...categories,
//   ];

//   return (
//     <aside className="hidden lg:block">
//       <div className="bg-white rounded-2xl border border-gray-200 p-6">
//         <h3 className="font-bold text-gray-900 text-lg">Categories</h3>

//         <div className="mt-5 space-y-3">
//           {sidebarCategories.map((item) => (
//             <button
//               key={item.id}
//               onClick={() => setCategory(item.title)}
//               className={`
//               block
//               w-full
//               text-left
//               px-4
//               py-3
//               rounded-xl
//               transition
//               duration-300

//               ${
//                 category === item.title
//                   ? "bg-green-600 text-white"
//                   : "text-gray-700 hover:bg-green-50 hover:text-green-600"
//               }
//             `}
//             >
//               {item.title}
//             </button>
//           ))}
//         </div>
//       </div>
//     </aside>
//   );
// };

// export default CategorySidebar;

const CategorySidebar = ({
  categories,
  category,
  setCategory,
}) => {


  const sidebarCategories = [
    {
      id: "all",
      title: "All Products",
    },
    ...categories,
  ];



  return (

    <aside className="hidden lg:block">

      <div className="
        bg-white
        rounded-2xl
        border
        border-gray-200
        p-6
      ">


        <h3 className="
          font-bold
          text-gray-900
          text-lg
        ">
          Categories
        </h3>



        <div className="mt-5 space-y-3">


          {sidebarCategories.map((item) => (


            <button

              key={item.id || item._id}

              onClick={() =>
                setCategory(item.title)
              }

              className={`
                block
                w-full
                text-left
                px-4
                py-3
                rounded-xl
                transition
                duration-300

                ${
                  category === item.title
                    ? "bg-green-600 text-white"
                    : "text-gray-700 hover:bg-green-50 hover:text-green-600"
                }
              `}

            >

              {item.title}

            </button>


          ))}


        </div>


      </div>


    </aside>

  );

};


export default CategorySidebar;
